import { type App, defineAsyncComponent } from 'vue'

const components = {
  AccountMenu: defineAsyncComponent(() => import('./AccountMenu.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
